import Vue from 'vue'
import axios from "axios";
import {
  showError,
  clearAllData
} from "@/global";
import { SingletonInter } from '../components/flowchart/nodes/_service/singletonInter';


// function request(request) {
//   const axiosSource = axios.CancelToken.source();
//   request.cancelToken = axiosSource.token;
//   cancelRequest = { ...request, cancel: axiosSource.cancel };
//   return request;
// }

function clearData(){
  clearAllData()
  delete axios.defaults.headers.common["Authorization"];
}

const success = res => res;

const error = err => {
  // console.log("entrou axios");
  // Permite que callers desativem o toast global pra mostrar mensagem propria.
  // Usado em chamadas ao RTO (que falham quando o RTO esta fora) para evitar
  // dumps tecnicos como "...maquina de destino as recusou ativamente. (localhost:7087)".
  if (err.config && err.config.skipGlobalErrorHandler) {
    return Promise.reject(err);
  }
  if (err.message == 'Network Error') {
    console.log("Network Error");
    clearData()    
    showError(SingletonInter.$t('problema-de-comunicacao-com-a-api'));
    window.location.pathname = process.env.VUE_APP_DIRECTORY ? `/${process.env.VUE_APP_DIRECTORY}/auth` : '/auth'
  } else if (500 == err.response.status) {
    showError(err.response.data);
  } else if (409 == err.response.status) {
    showError(err.response.data);
  } else if (400 == err.response.status) {
    showError(err.response.data);
  } else if (429 == err.response.status) {
    showError(err.response.data);
  } else if (401 == err.response.status) {
    if (err.response.data == "") {
      console.log("entrou 401 Token");      
      showError(SingletonInter.$t('token-expirado'));
      window.location.pathname = process.env.VUE_APP_DIRECTORY ? `/${process.env.VUE_APP_DIRECTORY}/auth` : '/auth'
    } else {
      showError(err.response.data);
    }
    clearData()
  }

  return Promise.reject(err);
};


axios.interceptors.response.use(success, error);

Vue.use({
  install(Vue) {
    Vue.prototype.$http = axios
  }
})